import React from "react";
import NewsletterFormPage from "../components/newsletters/NewsletterFormPage";

const NewsletterEdit = () => <NewsletterFormPage mode="edit" />;

export default NewsletterEdit;
